import React from 'react';
import { Whisper, Popover } from 'rsuite';
import RemindMeOutlineIcon from '@rsuite/icons/RemindOutline';

interface FormFieldErrorIconProps {
  errorMessage: React.ReactNode;
}

// '--rs-bg-overlay' is an RSuite CSS custom property not in React's CSSProperties
const popoverStyle: React.CSSProperties & Record<string, string> = {
  '--rs-bg-overlay': '#CACACA',
  background: '#CACACA',
  color: '#000',
  maxWidth: '200px',
};

const FormFieldErrorIcon = ({ errorMessage }: FormFieldErrorIconProps) => {
  return (
    <Whisper
      trigger={'click'}
      speaker={
        <Popover
          className="custom-popover"
          style={popoverStyle}
        >
          <div>{errorMessage}</div>
        </Popover>
      }
      placement={'auto'}
    >
      <RemindMeOutlineIcon
        aria-label="Show field error"
        className="remind-icon"
        role="button"
        tabIndex={0}
      />
    </Whisper>
  );
};

export default FormFieldErrorIcon;
